import { render, staticRenderFns } from "./LearningPage.vue?vue&type=template&id=1074db63&scoped=true"
import script from "./LearningPage.vue?vue&type=script&lang=js"
export * from "./LearningPage.vue?vue&type=script&lang=js"
import style0 from "./LearningPage.vue?vue&type=style&index=0&id=1074db63&prod&lang=scss"
import style1 from "./LearningPage.vue?vue&type=style&index=1&id=1074db63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1074db63",
  null
  
)

export default component.exports